import { createContext, useContext, useMemo } from 'react'
import { roles } from './roles'
import { useUser, useWorkspace } from 'src/hooks/user'

const AuthContext = createContext()

export function AuthProvider ({ children }) {
  const user = useUser()
  const workspace = useWorkspace()

  const role = useMemo(() => {
    if (!user || !workspace) {
      return 'Viewer'
    }

    const member = workspace.members?.find(
      (member) => member?.email === user.email
    )
    if (member) return member.role

    return user._id !== workspace.createdBy ? 'Viewer' : 'Admin'
  }, [user, workspace])

  const permissions = useMemo(() => roles[role] || roles.Viewer, [role])

  return (
    <AuthContext.Provider value={permissions}>{children}</AuthContext.Provider>
  )
}

export function useAuth () {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
